// The palette is available wherever a layout mounts it: `(dash)` (with its
// settings and internal layouts). Pages without it
// (docs, where DocSearch owns Cmd+K, marketing, auth) register no opener.
let _opener = $state<(() => void) | null>(null);

export function isCommandPaletteAvailable(): boolean {
  return _opener !== null;
}

export function registerOpener(fn: () => void): () => void {
  _opener = fn;
  return () => {
    // A layout swap can mount the next palette before this one unmounts.
    if (_opener === fn) _opener = null;
  };
}

export function openCommandPalette() {
  _opener?.();
}
